import { Link } from "react-router-dom";
import { useState, useContext } from "react";
import { UserContext } from "lib/UserContext";
import Debugger from "./Debugger";

export default function Footer(props) {
  const { user } = useContext(UserContext);
  return (
    <footer className="">
      {!user.timezone_name && (
        <div className="alert alert-warning text-center" role="alert">
          You haven't set a timezone yet.{" "}
          <Link className="" to="/settings">
            Set timezone
          </Link>
        </div>
      )}
      {!user.daily_goal && (
        <div className="alert alert-warning text-center" role="alert">
          You haven't set a daily goal yet.{" "}
          <Link className="" to="/settings">
            Set daily goal
          </Link>
        </div>
      )}
      <hr></hr>
      <p className="text-center text-secondary">
        <em>
          Data refreshes every 60 sec. Built by{" "}
          <Link className="text-secondary" to="https://scharl.click">
            Scott Scharl
          </Link>
          .
        </em>
      </p>
    </footer>
  );
}
